<template>
  <img class="logo" src="../../assets/images/evm_logo.png" alt="" />
</template>